export const WAITING_TIMEOUT = 180;
